export default __webpack_public_path__ + "static/media/qu.e1b05a34.svg";